// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--fVifv","header":"a10a3f92e9--header--3DeBz","list":"a10a3f92e9--list--2M4V-"};